module.exports = __webpack_public_path__ + "static/img/v.8ba7516.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v.png
// module id = UVvZ
// module chunks = 1